import { AuthorizationCodeTokenClient, OidcUrlHelper } from '@ori/auth';

import { IDENTITY_CLIENT_ID } from '../constants';

/**
 * Token extraction for development
 */
export const extractTokenFromUrl = async (identityUrl?: string) => {
  // extract token from URL; only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== 'production') {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);

    if (searchParams.has('state')) {
      const oidcUrlHelper = new OidcUrlHelper();

      const tokenClient = new AuthorizationCodeTokenClient({
        clientId: IDENTITY_CLIENT_ID,
        identityUrl: identityUrl ?? '',
      });
      oidcUrlHelper.storeAuthCodeFromParams(searchParams);
      await tokenClient.initializeTokenFromAuthorizationCode();
      oidcUrlHelper.handleRedirectAfterLogin();
    }
  }
};
